import { styled } from "@mui/material/styles";

export const Root = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 40px 12px 47px",
  width: "100%",
  height: 60,
});

export const Logo = styled("img")({
  display: "inline",
  marginRight: 47,
  fontSize: 0,
  verticalAlign: "middle",
});

export const Nav = styled("div")({
  flex: 1,
});

export const Actions = styled("div")({
  display: "flex",
  alignItems: "center",
});

export const Action = styled("div")({
  marginLeft: 20,
});
